import type { NuxtApp } from '#app'
import type { GQLSettings, GQLSettingsVariables } from './generated/settings'
import query from './settings.graphql'
import { getCacheOption } from '@core/plugins/apollo/cache-option'

export async function querySettings(
  nuxtApp: NuxtApp,
  domain: string = 'monito',
  noContent = false,
) {
  const { $apollo, $lang, $isPreview } = nuxtApp
  const { data, errors } = await $apollo.query<GQLSettings, GQLSettingsVariables>({
    query,
    variables: { lang: $lang, domain, noContent, preview: $isPreview.value },
    context: {
      cache: getCacheOption($isPreview.value),
    },
  })
  if (errors) {
    throw createGraphQLError(errors, 'Failed to load settings')
  }
  if (!data.settings) {
    throw new NotFoundError(
      `Settings not found. lang: ${$lang}, domain: ${domain} isPreview: ${$isPreview.value}`,
    )
  }
  return data.settings
}
